// missions.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_MISSIONS_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({
  sections: [],
  contents: {},
});

/**
 * Missions.
 * @module reducer/missions
 */
const missions = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_MISSIONS_DATA:
      return _MERGE_MISSION_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge missions data
 * @kind reducer/actionType
 * @name MERGE_MISSIONS_DATA
 * @param {object} payload - payload
 * @param {array} payload.selectPath - select path
 * @param {any} payload.data - data
 * @return {Immutable.Map} New state
 */
const _MERGE_MISSION_DATA = payload => state => {
  const data = fromJS(payload.data);
  if (Array.isArray(payload.data)) {
    return state.setIn(payload.selectPath, data);
  }
  return state.mergeIn(payload.selectPath, data);
};

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default missions;
